import { useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { LIBRARY_ID } from '../gallery/config';
import { applyExifDeepLink, INITIAL_GALLERY_STATE, type ExifDeepLink } from '../gallery/state';
import { galleryLinkFor } from '../gallery/url-state';
import { ExifToolModal } from './ExifToolModal';

/**
 * Route de l'OUTIL EXIF (`/outils/exif`) — « tout dans l'URL ».
 *
 * Rend la PAGE Outil EXIF sous l'en-tête persistant (× / fil d'Ariane = retour
 * galerie ; ce n'est plus une modale).
 * Le lien profond « carte → galerie filtrée » NAVIGUE vers la route galerie avec
 * les bons query params (le filtre EXIF vit désormais dans l'URL, adressable).
 *
 * Sans bibliothèque associée au compte, il n'y a rien à outiller → redirection
 * vers l'accueil (comportement inchangé : l'entrée était gated côté galerie).
 */
export function ExifToolRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const { user } = useAuth();
  const libraryId = user?.libraryId ?? LIBRARY_ID;

  const onClose = useCallback(() => navigate('/'), [navigate]);

  const onDeepLink = useCallback(
    (link: ExifDeepLink) => {
      // Repart d'un état propre (comme `applyExifDeepLink`) puis sérialise en URL.
      const next = applyExifDeepLink(INITIAL_GALLERY_STATE, link);
      navigate(galleryLinkFor(next));
    },
    [navigate],
  );

  if (!libraryId) return <Navigate to="/" replace />;

  return <ExifToolModal libraryId={libraryId} onClose={onClose} onDeepLink={onDeepLink} />;
}
